import { graphql } from '@/gql';

export const ASSIGN_INBOUND_EMAIL_TO_PROJECT_MUTATION = graphql(`
  mutation AssignInboundEmailToProject($inboundEmailId: ID!, $projectId: ID!) {
    assignInboundEmailToProject(
      inboundEmailId: $inboundEmailId
      projectId: $projectId
    ) {
      id
      status
      assignedProject {
        id
        reference
      }
    }
  }
`);
